import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";

const RefundPolicy = () => {
  return (
    <>
      <RootLayout>
        <Animation />

        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Refund Policy"} />
        <section className="about-two py-60 position-relative z-1">
          <div className="position-relative">
            <div className="container">
              <div className="row gy-4 align-items-center">
                <div className="col-lg-12">
                  <div className="join-community__content">
                    <div className="mb-40">
                      <h2
                        className="mb-24"
                        data-aos="fade-up"
                        data-aos-duration="800"
                      >
                        Cancellation of Admission / Refund Policy of Fees
                      </h2>
                      <p
                        className="text-neutral-500 text-line-2"
                        data-aos="fade-up"
                        data-aos-duration="800"
                        data-aos-delay="120"
                      >
                        <b>NATIONAL PUBLIC SCHOOL-KUDLU</b> reserves the right
                        to cancel the admission / registration of the student
                        during any period of the academic session. Once the
                        student admission process is completed,{" "}
                        <b>
                          no refund of fees to the student would be entertained.
                        </b>
                        <br />
                        <br />
                        <h5>Cancellation by the Parent</h5>
                        If the parent chooses to withdraw the admission of the
                        student from the school for any reason whatsoever,{" "}
                        <b>
                          no refund of amount paid would be given back. If for
                          any reason, the parent / student has paid more than
                          the required amount at any time during the academic
                          session either by cheque, draft, credit/debit card,
                          Electronic Fund Transfer or cash, the excess tuition
                          fee amount collected would be adjusted against the
                          ensuing term payments.
                        </b>
                        <br />
                        <br />
                        <h5>Institution Name Terms</h5>
                        This website is owned and operated by the NATIONAL
                        PUBLIC SCHOOL-KUDLU Administration and Staff. The
                        website has been structured to provide information
                        related to <b>School and school</b> activities and
                        directly reflect all policies and procedures set forth
                        by the Management. National Public School-Kudlu has the
                        right, at any time, to change or discontinue any feature
                        or aspect of this website, for any reason; that is,
                        without limitation, availability or equipment needed for
                        accessing and utilizing this website.
                        <br />
                        <br />
                        <h5>Fee Payment</h5>
                        Parents must ensure that School fees are paid on time as
                        per the dates communicated periodically. Timely payment
                        helps us maintain smooth administrative operations.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default RefundPolicy;
